interface BookingCounts {
    countAdults?: number | null;
    countKids?: number | null;
    countHighchairs?: number | null;
}

/**
 * Adults, kids and highchairs are three independent numbers: 2 adults + 2 kids +
 * 1 highchair is 5 guests. Highchairs are never part of the kids count.
 */
export const totalGuests = (b: BookingCounts): number =>
    (b.countAdults ?? 0) + (b.countKids ?? 0) + (b.countHighchairs ?? 0);

/** Per-person pricing (cancellation fee) is based on adults and kids only. */
export const payingGuests = (b: BookingCounts): number => (b.countAdults ?? 0) + (b.countKids ?? 0);

/** Same as {@link totalGuests} for the form-field names (adults/kids/highchairs). */
export const totalGuestsFromForm = (v: {
    adults?: number | null;
    kids?: number | null;
    highchairs?: number | null;
}): number => (v.adults ?? 0) + (v.kids ?? 0) + (v.highchairs ?? 0);

/** e.g. "2 Adults, 2 Kids, 1 Highchair" — zero kids/highchairs are omitted. */
export const formatGuestBreakdown = (b: BookingCounts): string => {
    const adults = b.countAdults ?? 0;
    const kids = b.countKids ?? 0;
    const highchairs = b.countHighchairs ?? 0;
    const parts = [`${adults} ${adults === 1 ? "Adult" : "Adults"}`];
    if (kids > 0) parts.push(`${kids} ${kids === 1 ? "Kid" : "Kids"}`);
    if (highchairs > 0)
        parts.push(`${highchairs} ${highchairs === 1 ? "Highchair" : "Highchairs"}`);
    return parts.join(", ");
};
